// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { GetData, GetResponse, GetError, GetVenueTimeZoneData, GetVenueTimeZoneResponse, GetVenueTimeZoneError, GetTestOrderData, GetTestOrderResponse, GetTestOrderError, AddOrUpdateProductsData, AddOrUpdateProductsResponse, AddOrUpdateProductsError, BulkDeleteOrderLinesData, BulkDeleteOrderLinesResponse, BulkDeleteOrderLinesError, GetCurrentOrderData, GetCurrentOrderResponse, GetCurrentOrderError, UpdateCustomerDetailsData, UpdateCustomerDetailsResponse, UpdateCustomerDetailsError, GetOrderByTransactionReferenceData, GetOrderByTransactionReferenceResponse, GetOrderByTransactionReferenceError, ApplyDiscountCodeData, ApplyDiscountCodeResponse, ApplyDiscountCodeError, CreateTransactionTokenData, CreateTransactionTokenResponse, CreateTransactionTokenError, GetImageData, GetImageResponse, GetImageError, GetProductsAvailableOnDateData, GetProductsAvailableOnDateResponse, GetProductsAvailableOnDateError, GetLastBookableDateData, GetLastBookableDateResponse, GetLastBookableDateError, GetTimeSlotAvailabilityData, GetTimeSlotAvailabilityResponse, GetTimeSlotAvailabilityError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class AbpApplicationConfigurationService {
    public static get<ThrowOnError extends boolean = false>(options?: Options<GetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetResponse, GetError, ThrowOnError>({
            url: '/api/abp/application-configuration',
            ...options
        });
    }
    
}

export class AppConfigurationService {
    public static getVenueTimeZone<ThrowOnError extends boolean = false>(options?: Options<GetVenueTimeZoneData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetVenueTimeZoneResponse, GetVenueTimeZoneError, ThrowOnError>({
            url: '/api/public/app-configuration/venue-time-zone',
            ...options
        });
    }
    
}

export class OrderService {
    public static getTestOrder<ThrowOnError extends boolean = false>(options?: Options<GetTestOrderData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetTestOrderResponse, GetTestOrderError, ThrowOnError>({
            url: '/api/public/order/test-order',
            ...options
        });
    }
    
    public static addOrUpdateProducts<ThrowOnError extends boolean = false>(options?: Options<AddOrUpdateProductsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<AddOrUpdateProductsResponse, AddOrUpdateProductsError, ThrowOnError>({
            url: '/api/public/order/or-update-products',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static bulkDeleteOrderLines<ThrowOnError extends boolean = false>(options?: Options<BulkDeleteOrderLinesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<BulkDeleteOrderLinesResponse, BulkDeleteOrderLinesError, ThrowOnError>({
            url: '/api/public/order/bulk-delete-order-lines',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getCurrentOrder<ThrowOnError extends boolean = false>(options?: Options<GetCurrentOrderData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCurrentOrderResponse, GetCurrentOrderError, ThrowOnError>({
            url: '/api/public/order/current-order',
            ...options
        });
    }
    
    public static updateCustomerDetails<ThrowOnError extends boolean = false>(options?: Options<UpdateCustomerDetailsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).put<UpdateCustomerDetailsResponse, UpdateCustomerDetailsError, ThrowOnError>({
            url: '/api/public/order/customer-details',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getOrderByTransactionReference<ThrowOnError extends boolean = false>(options?: Options<GetOrderByTransactionReferenceData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetOrderByTransactionReferenceResponse, GetOrderByTransactionReferenceError, ThrowOnError>({
            url: '/api/public/order/order-by-transaction-reference',
            ...options
        });
    }
    
    public static applyDiscountCode<ThrowOnError extends boolean = false>(options?: Options<ApplyDiscountCodeData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<ApplyDiscountCodeResponse, ApplyDiscountCodeError, ThrowOnError>({
            url: '/api/public/order/apply-discount-code',
            ...options
        });
    }
    
}

export class PaymentService {
    public static createTransactionToken<ThrowOnError extends boolean = false>(options?: Options<CreateTransactionTokenData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<CreateTransactionTokenResponse, CreateTransactionTokenError, ThrowOnError>({
            url: '/api/public/payment/transaction-token',
            ...options
        });
    }
    
}

export class ProductService {
    public static getImage<ThrowOnError extends boolean = false>(options: Options<GetImageData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetImageResponse, GetImageError, ThrowOnError>({
            url: '/api/public/product/{id}/image',
            ...options
        });
    }
    
}

export class ScheduleService {
    public static getProductsAvailableOnDate<ThrowOnError extends boolean = false>(options?: Options<GetProductsAvailableOnDateData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetProductsAvailableOnDateResponse, GetProductsAvailableOnDateError, ThrowOnError>({
            url: '/api/public/schedule/products-available-on-date',
            ...options
        });
    }
    
    public static getLastBookableDate<ThrowOnError extends boolean = false>(options?: Options<GetLastBookableDateData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetLastBookableDateResponse, GetLastBookableDateError, ThrowOnError>({
            url: '/api/public/schedule/last-bookable-date',
            ...options
        });
    }
    
}

export class TimeSlotService {
    public static getTimeSlotAvailability<ThrowOnError extends boolean = false>(options?: Options<GetTimeSlotAvailabilityData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetTimeSlotAvailabilityResponse, GetTimeSlotAvailabilityError, ThrowOnError>({
            url: '/api/public/time-slot/time-slot-availability',
            ...options
        });
    }
    
}